import Helmet from "react-helmet"
import React from "react"
import ExtendedHomepage from "src/components/extendedHomepage"
import HomepageLayout from "src/layouts/homepage"
import NonSearchDisclosure from "src/components/nonsearchdisclosure"
import ChromeCTADisclosure from "src/components/chromectadisclosure"
import {isIeEdge,isChrome,isFirefox} from "@tightrope/lpscripts/browserdetect"


const homepageData = import("./homepage.json");

export default function HomePage() {
  let disclosure = null;
  if(isChrome()){
    disclosure = <ChromeCTADisclosure data={homepageData}></ChromeCTADisclosure>; 
  }
  else{
    disclosure = <NonSearchDisclosure data={homepageData}></NonSearchDisclosure>;
  }
  return(
    <HomepageLayout>
      <Helmet>
      <style type="text/css">{`


          #ctadisclosurenewtab-module--ctadisclaimer, #ctadisclosure-module--ctadisclaimer {
            font-weight: 300;
            color: #f0f0f0;
          }

          #ctadisclosurenewtab-module--ctadisclaimer p, #ctadisclosure-module--ctadisclaimer p {
            color: #f0f0f0;
          }
        `}</style>

      <title>FabTab</title></Helmet>
      <ExtendedHomepage data={homepageData}>
        {disclosure}
      </ExtendedHomepage>
    </HomepageLayout>
  )
}
